import angular, { ICompileService, IScope } from 'angular';
import { ModalOverlayService } from '../modal-overlay/modal-overlay.service';

export default class AutocompleteController {
  public customModel!: string | undefined;

  public options!: string[];

  private modalOverlayService: ModalOverlayService;

  private $compile: ICompileService;

  private $scope: IScope;

  public selectableOptions: { description: string }[] = [];

  constructor(
    modalOverlayService: ModalOverlayService,
    $compile: ICompileService,
    $scope: IScope,
  ) {
    'ngInject';

    this.modalOverlayService = modalOverlayService;
    this.$compile = $compile;
    this.$scope = $scope;
  }

  public showOptions = (event: Event): void => {
    if (!event.target) return;

    this.selectableOptions = this.options.map((o) => ({ description: o }));

    const optionsHtml = /* html */`
      <ul class="ab-select-options">
        <ab-select-option ng-repeat="option in $ctrl.selectableOptions track by $index" ng-click="$ctrl.selectOption(option.description)"></ab-select-option>
      </ul>
    `;

    const inputPosition = (event.target as any).getBoundingClientRect();
    const compiledHtml = this.$compile(optionsHtml)(this.$scope);

    setTimeout(() => {
      const optionsHeight = angular.element(compiledHtml)[0].clientHeight;

      // todo: objectHeight is always 0 here, because the object will be
      // todo: only rendered after it is shown
      // todo: therefore the elements height is only then known

      this.modalOverlayService.show((compiledHtml as any), inputPosition, optionsHeight, true);
    }, 50);
  };

  public selectOption = (option: string): void => {
    this.customModel = option;
  };
}
